import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animations';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    { label: 'Unique Miniatures', value: 12*4 },
    { label: 'Paint Colors', value: 62+2+4+2 },
    { label: 'Quality Brushes', value: 9 },
    { label: 'Years of Experience', value: 5 },
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <h2 className="heading-2 text-white mb-6">The Journey of Legendary Brushstrokes</h2>
            <p className="text-slate-300 mb-6">
              Born from a successful program serving educational needs and refined through iterative feedback, Legendary Brushstrokes offers high-quality, uniquely sculpted miniatures, curated paints and brushes, and engaging supporting materials.
            </p>
            <p className="text-slate-300 mb-6">
              Available in distinct Retail and OEM formats, the product balances a premium, accessible experience with scalable options, positioning Dungeon Labs as a creator of complete, thematic hobby solutions.
            </p>
            <p className="text-slate-300">
              The upcoming integration of the proprietary Dungeon Labs Paints and Dungeon Labs Brushes lines further solidifies this vision, ensuring quality control, supply stability, and brand consistency.
            </p>
          </motion.div>
          
          <div ref={ref} className="grid grid-cols-2 gap-8">
            {stats.map((stat, index) => (
              <motion.div 
                key={index}
                className="bg-slate-800 p-6 rounded-lg border border-slate-700 text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <h3 className="text-4xl font-bold text-purple-400 mb-2">
                  {inView ? (
                    <CountUp end={stat.value} duration={2} />
                  ) : (
                    '0'
                  )}
                </h3>
                <p className="text-slate-300">{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
